import type { ProposalStatus } from '@shared';

// Mapping from proposal status → chip tone class. Mirrors StatusChip for
// requests so the operator UI feels consistent across the two domains.
const META: Record<ProposalStatus, { label: string; tone: 'neutral' | 'amber' | 'accent' | 'green' | 'red' }> = {
  draft:     { label: 'Draft',     tone: 'neutral' },
  sent:      { label: 'Sent',      tone: 'amber' },
  accepted:  { label: 'Accepted',  tone: 'green' },
  declined:  { label: 'Declined',  tone: 'red' },
  withdrawn: { label: 'Withdrawn', tone: 'red' },
  expired:   { label: 'Expired',   tone: 'neutral' },
};

export function ProposalStatusChip({ status }: { status: ProposalStatus }) {
  const m = META[status];
  const cls =
    m.tone === 'accent' ? 'accent' :
    m.tone === 'amber'  ? 'amber'  :
    m.tone === 'green'  ? 'green'  :
    m.tone === 'red'    ? 'red'    : '';
  return (
    <span className={`chip ${cls}`}>
      <span style={{ width: 5, height: 5, borderRadius: '50%', background: 'currentColor' }} />
      {m.label}
    </span>
  );
}

export function proposalStatusLabel(status: ProposalStatus): string {
  return META[status].label;
}
